// extracted by mini-css-extract-plugin
module.exports = {"container":"SplitContainer_container__1k9-I","pane":"SplitContainer_pane__1bG33","opened":"SplitContainer_opened__1OL0C","disableResize":"SplitContainer_disableResize__3pLt6"};